export const MAX_UPLOAD_SIZE_BYTES = 50 * 1024 * 1024;

export const ALLOWED_UPLOAD_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'txt',
  'zip',
  'rar'
];

export const UPLOAD_ACCEPT_ATTRIBUTE = ALLOWED_UPLOAD_EXTENSIONS.map((extension) => `.${extension}`).join(',');

const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== '';

const pad = (value) => String(value).padStart(2, '0');

const normalizeTimeValue = (value) => {
  const trimmedValue = String(value).trim();

  if (/^\d{2}:\d{2}$/.test(trimmedValue)) {
    return `${trimmedValue}:00`;
  }

  if (/^\d{2}:\d{2}:\d{2}$/.test(trimmedValue)) {
    return trimmedValue;
  }

  return null;
};

const toLocalDateTimeString = (date) => (
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
);

export const validateTicketUploadFile = (file) => {
  if (!file) {
    return '';
  }

  const extension = file.name.includes('.')
    ? file.name.split('.').pop().toLowerCase()
    : '';

  if (!ALLOWED_UPLOAD_EXTENSIONS.includes(extension)) {
    return `نوع الملف غير مدعوم. الأنواع المسموح بها: ${UPLOAD_ACCEPT_ATTRIBUTE}`;
  }

  if (file.size > MAX_UPLOAD_SIZE_BYTES) {
    return `حجم الملف كبير جداً. الحد الأقصى هو ${Math.round(MAX_UPLOAD_SIZE_BYTES / (1024 * 1024))} MB.`;
  }

  return '';
};

export const buildTicketDateTimePayload = ({
  date,
  time,
  autoFillNow = true,
  missingMessage = 'يرجى إدخال التاريخ والوقت معاً.',
  invalidMessage = 'صيغة التاريخ أو الوقت غير صحيحة.'
}) => {
  const hasDate = hasValue(date);
  const hasTime = hasValue(time);

  if (hasDate !== hasTime) {
    return { error: missingMessage, value: null };
  }

  if (!hasDate && !hasTime) {
    if (!autoFillNow) {
      return { error: null, value: null };
    }

    return {
      error: null,
      value: toLocalDateTimeString(new Date())
    };
  }

  const normalizedTime = normalizeTimeValue(time);

  if (!normalizedTime) {
    return { error: invalidMessage, value: null };
  }

  const rawValue = `${String(date).trim()}T${normalizedTime}`;
  const parsedValue = new Date(rawValue);

  if (Number.isNaN(parsedValue.getTime())) {
    return { error: invalidMessage, value: null };
  }

  return {
    error: null,
    value: rawValue
  };
};

export const splitTicketDateTime = (value) => {
  if (!value) {
    return { date: '', time: '' };
  }

  const parsedValue = new Date(value);

  if (Number.isNaN(parsedValue.getTime())) {
    return { date: '', time: '' };
  }

  return {
    date: `${parsedValue.getFullYear()}-${pad(parsedValue.getMonth() + 1)}-${pad(parsedValue.getDate())}`,
    time: `${pad(parsedValue.getHours())}:${pad(parsedValue.getMinutes())}`
  };
};

export const buildApiErrorMessage = (error, fallbackMessage) => {
  const responseData = error?.response?.data;
  const mainMessage = responseData?.error || fallbackMessage;
  const details = responseData?.details;

  return [mainMessage, details].filter(Boolean).join(' ');
};
